import React, { Component } from 'react';
import ReactPhotoCollageContainer from "./react-photo-collage/react-photo-collage-container";

class Portfolio extends Component {
  render() {
    // let projectImages;
    // if(this.props.data){
    //   projectImages = this.props.data.projects.map(function(projects){
    //     var projectImage = './images/portfolio/'+projects.image;
    //     return (
    //       {source: projectImage}
    //     );
    //   })
    // }

    const setting = {
      width: '100%',
      height: ['500px', '250px', '500px', '250px', '500px', '250px', '250px', '300px', '500px', '500px', '250px', '500px', '350px'],
      layout: [1,5,1,4,1,2,2,2,1,1,3,2,3],
      photos: [
        { source: './images/portfolio/rit1.png', shortInfo: 'Dynamically-Loaded RIT Site' },
        { source: './images/portfolio/rit2.png', shortInfo: 'Dynamically-Loaded RIT Site' },
        { source: './images/portfolio/rit3.png', shortInfo: 'Dynamically-Loaded RIT Site' },
        { source: './images/portfolio/rit4.png', shortInfo: 'Dynamically-Loaded RIT Site' },
        { source: './images/portfolio/rit5.png', shortInfo: 'Dynamically-Loaded RIT Site' },
        { source: './images/portfolio/rit6.png', shortInfo: 'Dynamically-Loaded RIT Site' },
        { source: './images/portfolio/linux.png', shortInfo: 'Learn Linux Site' },
        { source: './images/portfolio/vain1.png', shortInfo: 'Victorian Art Installation Network' },
        { source: './images/portfolio/vain2.png', shortInfo: 'Victorian Art Installation Network' },
        { source: './images/portfolio/vain3.png', shortInfo: 'Victorian Art Installation Network' },
        { source: './images/portfolio/vain4.png', shortInfo: 'Victorian Art Installation Network' },
        { source: './images/portfolio/pictionary.jpg', shortInfo: 'LAN Pictionary Game' },
        { source: './images/portfolio/vaccine1.png', shortInfo: 'Mass Vaccination Management Project' },
        { source: './images/portfolio/vaccine2.png', shortInfo: 'Mass Vaccination Management Project' },
        { source: './images/portfolio/advoidit.jpg', shortInfo: 'Advoidit Venture', link: "https://youtu.be/vf27Yaq-um8" },
        { source: './images/portfolio/d3.png', shortInfo: 'D3 Insurance Visualization', link: "http://devinmochrie.com/insurance_facts/justifying_homeowners/index.html" },
        { source: './images/portfolio/dislike.png', shortInfo: 'Youtube Dislike Counter Project' },
        { source: './images/portfolio/dislike2.jpg', shortInfo: 'Youtube Dislike Counter Project' },
        { source: './images/portfolio/astrostation.png', shortInfo: 'Astrostation Site', link: "https://astrostation.me/" },
        { source: './images/portfolio/dashcam1.jpg', shortInfo: 'Bikelane Bounty Project' },
        { source: './images/portfolio/dashcam2.gif', shortInfo: 'Bikelane Bounty Project' },
        { source: './images/portfolio/dashcam3.png', shortInfo: 'Bikelane Bounty Project' },
        { source: './images/portfolio/dashcam4.gif', shortInfo: 'Bikelane Bounty Project' },
        { source: './images/portfolio/depictionary1.png', shortInfo: 'Depictionary Project' },
        { source: './images/portfolio/depictionary2.png', shortInfo: 'Depictionary Project' },
        { source: './images/portfolio/tempost1.png', shortInfo: 'Tempost Venture' },
        { source: './images/portfolio/neeroh1.png', shortInfo: 'Neeroh Venture' },
        { source: './images/portfolio/walkin1.png', shortInfo: 'Walk-In Venture' },
      ],
      showNumOfRemainingPhotos: true
    };

    return (
      <section id="portfolio">
        <div className="row portfolioItem">
          <div className="twelve columns collapsed">
              <h1>Projects and Ventures</h1>
              <div className="row-wrap">
                <ReactPhotoCollageContainer {...setting} />
              </div>
            </div>
        </div>
      </section>
    );
  }
}

export default Portfolio;



// WEBPACK FOOTER //
// ./src/Components/Portfolio.js